<new-flowbanner [showPromo]="true"></new-flowbanner>
<section class="general-pausa">
  <div class="container d-flex justify-content-center align-items-center vh-60">
    <form class="w-100 w-md-50 p-4" [formGroup]="PolicyHolder" (ngSubmit)="enviarFormulario()">
      <div class="text-center mb-4">
        <h2 class="cotizacion-heading">Cotización en pausa</h2>
        @if(!serviceIsFailed){
          <p class="cotizacion-text">
          Tenemos otro producto disponible para ti. Déjanos tus datos y nos
          pondremos en contacto contigo ;)
          </p>
        }@else{
          <p class="cotizacion-text cotizacion-text--failed">
          El proceso de validación ha fallado. <br>
          <span>¡No te preocupes!</span> <br> 
          Déjanos tus datos y nos pondremos en contacto contigo ;)
          </p>
        } 
      </div>

      <div class="mb-3 cotizacion-input-container">
        <label for="LastName" class="form-label cotizacion-label" [ngClass]="getLabelClasses('LastName')">*Nombre</label>
        <input
          (keydown)="validateAlpha($event)"
          id="LastName"
          type="text"
          class="form-control cotizacion-input"
          formControlName="LastName"
          placeholder="Escribe tu nombre"
          [class.is-invalid]="isValidField('LastName')"
        />
        <div *ngIf="isValidField('LastName')" class="invalid-feedback">
          {{ getFieldError('LastName') }}
        </div>
      </div>

      <div class="mb-3 cotizacion-input-container">
        <generalinput [form]="PolicyHolder"  controlName="MobilePhone"  [isNumberOnly]='true' label="*Número de celular" alertMessage="Asegúrate de ingresar un número válido de 10 dígitos" placeholder="Ej: 3004263078" ></generalinput>
      </div>

      <div class="mb-3 cotizacion-input-container">
        <generalinput [form]="PolicyHolder" controlName="Mail" label="*Correo electrónico"
        alertMessage="Asegúrate de incluir el símbolo '@'" placeholder="Ej: nombre@correo.com">
        </generalinput>
      </div>

      <div class="mb-3 cotizacion-input-small">
        <small class="cotizacion-small">*Los campos son obligatorios</small>
      </div>

      <button type="submit" class="btn btn-primary d-flex justify-content-center align-items-center" [disabled]="PolicyHolder.invalid || isClicked">Enviar</button>
    </form>
  </div>
</section>

<app-footer-app></app-footer-app>
